import _ from 'underscore'
import ApiError from '@/libs/ApiError'
import { useRouter } from 'vue-router'
import repos from '@/libs/Repository'

export function useExecutor () {
  const router = useRouter()

  // const back = () => {
  //   router.back()
  // }

  const exec = (func, setErrors) => {
    try {
      const promise = func()
      try {
        if (promise) {
          promise.catch(e => {
            onError(e, setErrors)
            return Promise.resolve()
          })
        }
        return promise
      } catch (error) {
        console.error(error)
      }
    } catch (error) {
      onError(error, setErrors)
    }
  }

  const onError = (error, setErrors) => {
    try {
      if (ApiError.isInstance(error)) {
        if (error.status === 422 && (error.data && error.data.errors) && typeof setErrors === 'function') {
          setErrors(
            Object.fromEntries(
              Object.entries(error.data.errors).map(([key, value]) => [key, _.first(value)])
            )
          )
          return Promise.resolve()
        } else if (ApiError.isAuthError(error)) {
          repos.clearToken()
          router.replace('/login')
        } else if (ApiError.isTimeout(error)) {
          router.replace('/error/network-timeout')
        } else if (ApiError.isNetworkError(error)) {
          router.replace('/error/network-error')
        } else {
          if (error.status) {
            console.error(JSON.stringify(error))
            repos.clearToken()
            router.replace('/error/network-error')
          } else {
            handleError(error)
          }

          return
        }
      } else {
        handleError(error)
        return
      }
    } catch (err) {
      handleError(err)
    }
  }

  const handleError = (error) => {
    repos.clearToken()
    console.error(error)
    router.replace('/error/sorry')
  }

  return { exec }
}
